import React, { useEffect, useState } from "react";
import { Text } from "react-native";
import { CommonButton } from "../../components/buttons";
import { fonts } from "../../common/styles/fonts";
import { useNavigate, useParams } from "react-router-dom";
import { InputField } from "../../components/InputField";
import { Header } from "../../components/Header";
import { CommonScreenCard } from "../../components/CommonScreenCard";
import useUniqueDispatch, {
  isData,
  isLoading,
  useSelector,
} from "../../utils/redux-utils";
import { userForgotPasswordAction } from "../../store/user/action";
import { RootState } from "../../store/root-reducer";
export const ForgotPasswordPage = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  const [forgotPasswordToken, forgotPassword] = useUniqueDispatch(
    userForgotPasswordAction.request
  );

  const userRequest = useSelector((store: RootState) => store.user);

  const isSending = isLoading(userRequest, forgotPasswordToken);
  const isSent = userRequest.lastOpId === forgotPasswordToken;

  const forgotPasswordHandle = () => {
    forgotPassword([{ email }]);
  };

  const disableButton = !email;
  return (
    <CommonScreenCard>
      <Header onPressLeft={() => navigate(-1)} />
      <Text style={[fonts.title, { marginBottom: 8 }]}>Forgot my password</Text>
      <Text style={[fonts.mediumText_regular, { marginBottom: 51 }]}>
        Type in email attached to your account
      </Text>
      <InputField
        style={{ marginBottom: 170 }}
        value={email}
        onChangeText={setEmail}
        placeholder="Email"
      />

      <CommonButton
        textStyle={fonts.mediumText_bold}
        title="Send email"
        isLoading={isSending}
        type={disableButton ? "black" : "blackFilled"}
        onPress={() => forgotPasswordHandle()}
        disabled={disableButton}
      />
      {isSent && (
        <Text style={[fonts.mediumText_regular, { marginTop: 24 }]}>
          We have sent you email with restore password link.
        </Text>
      )}
    </CommonScreenCard>
  );
};
